
  document.addEventListener('DOMContentLoaded', function() {
    // Configuración de menús
    const menuConfigs = [
      { 
        triggerId: 'mlb', 
        submenuId: 'mlb-submenu' 
      },
      { 
        triggerId: 'nfl', 
        submenuId: 'nfl-submenu' 
      },      
      { 
        triggerId: 'collegiate',   
        submenuId: 'collegiate-submenu' 
      }
    ];
    
    // Configurar cada menú
    menuConfigs.forEach(function(config) {
      const triggerLink = document.getElementById(config.triggerId);
      const submenu = document.getElementById(config.submenuId); 
      
      if (triggerLink && submenu) {
        // Evento para abrir el submenú
        triggerLink.addEventListener('click', function(e) {
          e.preventDefault(); // Prevenir navegación
          submenu.style.display = 'block';
          
          // Pequeño retraso para que la transición funcione
          setTimeout(function() {
            submenu.classList.add('active');
          }, 10);
        });
      }
    });
    
    // Manejar todos los botones de retroceso
    document.querySelectorAll('.submenu-back-btn').forEach(function(backBtn) {
      backBtn.addEventListener('click', function() {
        const parentSubmenu = this.closest('.mobile-teams-submenu');
        if (parentSubmenu) {
          parentSubmenu.classList.remove('active');
          
          // Esperar a que termine la transición
          setTimeout(function() {
            parentSubmenu.style.display = 'none';
          }, 300);
        }
      });
    });
    
    // Alternativa: Si los botones de retroceso están dentro del header
    document.querySelectorAll('.submenu-header').forEach(function(header) {
      header.addEventListener('click', function() {
        const parentSubmenu = this.closest('.mobile-teams-submenu');
        if (parentSubmenu) {
          parentSubmenu.classList.remove('active');
          
          // Esperar a que termine la transición
          setTimeout(function() {
            parentSubmenu.style.display = 'none';
          }, 300);
        }
      });
    });
  });
